import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";

interface IProps {
  closeModal?: () => void;
  title?: any;
  style?: any;
}

const CModalHeader = ({ closeModal, title }: IProps) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        padding: title === 'transfer' ? '25px 0' : '25px 15px',
      }}
    >
      <Text size={18}>{t(title)}</Text>
      <CButton
        icon={<IconX size={20} color={textw} />}
        style={{
          padding: 3,
          borderRadius: 50,
          cursor: "pointer"
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default CModalHeader;
